import { render, staticRenderFns } from "./License.vue?vue&type=template&id=7fe1f76c&scoped=true"
import script from "./License.vue?vue&type=script&setup=true&lang=js"
export * from "./License.vue?vue&type=script&setup=true&lang=js"
import style0 from "./License.vue?vue&type=style&index=0&id=7fe1f76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1f76c",
  null
  
)

export default component.exports